import {useState, createContext, useContext, useEffect, ReactNode} from "react"
import { useNavigate } from "react-router-dom";

export type Company = {
    companyId:number,
    companyName:string
}

type AuthContextType = {
    company : Company | null,
    Login: (company:Company) => void,
    Logout: () => void
}

const AuthContext = createContext<AuthContextType|undefined>(undefined);

export const AuthProvider = ({children} : {children:ReactNode}) => {
    const [company, setCompany] = useState<Company | null>(null);
    let navigate = useNavigate();

    useEffect(() => {
        const storedCompany = sessionStorage.getItem("company");
        if (storedCompany)
        {
            setCompany(JSON.parse(storedCompany));
        }
    }, []);


    const Login = (newCompany: Company) =>{
        sessionStorage.setItem("company", JSON.stringify(newCompany));
        setCompany(newCompany);
    }

    const Logout = () => {
        sessionStorage.removeItem("user");
        setCompany(null);
        navigate("/SignIn");
    }   

    return (
        <AuthContext.Provider value={{ company, Login, Logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const UseAuth = () => {
    const context = useContext(AuthContext);

    if(!context)
    {
        throw new Error("UseAuth must be used inside an AuthProvider");
    }
    return context;
}